import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-137" data-mp="2av1tc76drn2s">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-138" data-mp="38ayz6oxtmpld">
          <a href={CHECKOUT_URL} className="animate-cta-shake mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-cta px-4 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_24px_-8px_rgba(30,158,87,0.7)] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-light sm:text-base" data-id="element-139" data-mp="335dojrm2apto">
            Get Facelift Blueprint™ — $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-140" data-mp="26dtpcimpwsii" />
          </a>
        </motion.div>}
    </AnimatePresence>;
}